import React, {useEffect, useState} from "react";
import settingsIcon from "../imgs/settings.png"
import notifyIcon from "../imgs/notification.png"
import messageIcon from "../imgs/messages.png"
import {ApiService} from "../api/ApiService";
import {Link} from "react-router-dom";
import {UserUtils} from "../utils/UserUtils";
import 'antd/lib/menu/style';
import 'antd/lib/style';
import more from "../imgs/more.png"
import TrainerAdvantageProgramDialog from "../components/dialog/TrainerAdvantageProgramDialog";
import AppBroadcast from "../components/dialog/AppBroadcast";
import PushNotificationWindow from "../components/dialog/PushNotificationWindow";
import { UserPushNotificationStore, UserState, userStore } from "../api/AuthService";
import { PushNotificationsService } from "../api/PushNotificationsService";
import { sidnavStore, SidenavState } from "../api/SidenavStore";
import { DriverProfile } from "../api/model/DriverProfile";

let broadcast: any = {};

const Toolbar = (props: any) => {

    const [notificationCount, setNotificationCount] = useState(0);
    const [trainerAdvantageNotificationId, settrainerAdvantageNotificationId] = useState<number>();
    const [showBroadcast, setShowBroadcast] = useState<boolean>(false);
    const [msgNotificationsCount, setMsgNotificationsCount] = useState<number>(0);
    const {toggleSidenav}: { toggleSidenav: () => void } = sidnavStore((state: SidenavState) => ({toggleSidenav: state.toggle}));
    const [showNotification, setShowNotification] = useState<boolean>(false);
    const {driver}: { driver: DriverProfile } = userStore((state: UserState) => ({driver: state.driver}));
    const {fleetMananerCode} = userStore((state: UserState) => ({fleetMananerCode: state.driver?.fleetManagerCode}));

    const sub1 = UserPushNotificationStore.subscribe(() => setShowNotification(true))
    const sub2 = UserPushNotificationStore.subscribe((state: any) => console.log("push data", state.data))

    useEffect(() => {
        initNotificationCount();
        console.log("checking user store", UserPushNotificationStore.getState().received);
        setShowNotification(UserPushNotificationStore.getState().received)
        // ApiService.getUnit("toolbar", driver.unit).then(it => console.log("unit", it))
        getConversations()
        ApiService.sendEventCommand("Inbox View", "eventCheck", "User has checked their inbox");
        checkForUpdates()
    }, [UserPushNotificationStore.getState().received]);
    
    const checkForUpdates = () => {
        setInterval(() => {
            getConversations();
        }, 300000);
    }

    function getConversations() {
        ApiService.chatConversationGet("Inbox", {}).then(it => {
            processConversations(it)
        })
    }
    
    function processConversations(convData: any) {
        console.log("convoData", convData);
        let tempNotificationsCount: number = 0
        for (let i = 0; i < convData.length; i++) {
            if (convData[i].lastMessage !== undefined) {   
                if (convData[i].lastMessage.read !== 1) {
                    // console.log("new stuff", convData[i]);
                    tempNotificationsCount += 1;
                }
            }
        }
        setMsgNotificationsCount(tempNotificationsCount)
    }
    

    const initNotificationCount = () => {
        if (!UserUtils.isAdmin() && !UserUtils.isDriverManager() && !UserUtils.isInspector()) {
            ApiService.checkForBroadcast("toolBar").then(it => {
                parseBroadcastContent(it);
            })
            ApiService.getPushNotifications("toolBar").then(it => {
                setNotificationCount(it.filter(notification => !notification.read).length);
                settrainerAdvantageNotificationId(it.find(notification => notification.type === 'trainerAdvantage' && !notification.read)?.id);
            });
        }
    }

    const parseBroadcastContent = (broadcastContent: any) => {
        if (typeof broadcastContent.message !== 'undefined') {
            console.log("broadcast message", broadcastContent.message);
            broadcast = broadcastContent.message
            if (localStorage.getItem("broadcastRead") !== null) {
                if (localStorage.getItem("broadcastRead") === broadcastContent.message.id.toString()) {
                    setShowBroadcast(false);
                } else {
                    setShowBroadcast(true);
                }
            }
        } else {
            return
        }
    }

    const acceptTrainerAdvantage = () => {
        ApiService.readPushNotification('trainerAdvantageProgramDialog', {id: trainerAdvantageNotificationId!}).then(() => initNotificationCount());
    }

    const readBroadcast = () => {
        localStorage.setItem("broadcastRead", broadcast.id.toString());
    }


    const handleResponse = (response: string, type: string, additionalInfo: any) => {
        console.log("data in", response, type, additionalInfo)
        if (type === "delivery") {
            onDeliveryResponse(response)
        } else if (type === "ready") {
            onReadyResponse(response, additionalInfo)
        }
    }

    const onReadyResponse = async (response: string, additionalInfo: any) => {
        console.log("response", additionalInfo);
        // ApiService.pollResultSubmit('readyForSolo', {responseId: UserPushNotificationStore.getState().responseId, answer: response}).then(() => PushNotificationsService.removeAllNotification());
        let emailList: string[] = await getEmailList();
        ApiService.sendEmail("readyForSolo", {to: emailList, subject: `Ready for solo for trainee: ${[additionalInfo]}`, body: `Trainer ${localStorage.getItem("username")?.toUpperCase()} has confirmed trainee ${additionalInfo} is ${response === "yes" ? "ready" : "not ready"} for solo`}).then(() => {});
        setShowNotification(false);
    }

    const onDeliveryResponse = (response: string) => {
        console.log("response", response);
        ApiService.pollResultSubmit('mondayDelivery', {responseId: UserPushNotificationStore.getState().responseId, answer: response}).then(() => PushNotificationsService.removeAllNotification());
        setShowNotification(false);
    }

    function getEmailList() {
        let emailList: string[] = []
        if (fleetMananerCode === "VFONT") {
            emailList = ["lbaker@westernexp.com"]
        } else if (fleetMananerCode === "PPV" || fleetMananerCode === "VALLE" || fleetMananerCode === "VNASH" || fleetMananerCode === "VVIRG") {
            emailList = ["chawkins@westernexp.com"]
        } else if (fleetMananerCode === "VLP" || fleetMananerCode === "FLP" || fleetMananerCode === "FNASH" || fleetMananerCode === "FNEREG") {
            emailList = ["jdmorris@westernexp.com"]
        }
        console.log("emailList", emailList);
        return emailList;
    }

    return (
        <div className="item-container d-flex justify-content-between" id="tooly">
            {showNotification ? <PushNotificationWindow onAccept={(e: any, t: any, a: any) => handleResponse(e, t, a)} showModal={showNotification} cancel={() => {setShowNotification(false)}}></PushNotificationWindow> : <></>}
            {!!trainerAdvantageNotificationId ? <TrainerAdvantageProgramDialog onAccept={() => acceptTrainerAdvantage()}></TrainerAdvantageProgramDialog> : <></>}
            {showBroadcast ? <AppBroadcast message={broadcast} onAccept={() => readBroadcast()}></AppBroadcast> : <></>}
            <div id="toolbar-left" className="d-flex w-100 gap-4">
                <div onClick={() => toggleSidenav()} className="pointer" style={{paddingTop: "3px"}}>
                    <img id="toolbar-image" src={more} alt="Toggle Sidenav"/>
                </div>
                {/* <div className="toolbar-search">
                    <Search onChange={handleSearch} featured={''}/>
                </div> */}
            </div>
            <div id="toolbar-right" className={`${props.pageName}NotificationLink`}>
                <Link to="/Inbox" id={`${props.pageName}MessageLink`}>
                    <img src={messageIcon} alt="messages" id={`${props.pageName}MessageLink`}/>
                    {msgNotificationsCount !== 0 ? <div className="notify-badge-msg"><p>{msgNotificationsCount}</p></div> : null}
                </Link>
                <Link style={{position: "relative"}} to="/notifications" id={`${props.pageName}NotificationLink`}>
                    <img src={notifyIcon} alt="notify" id={`${props.pageName}NotificationLink`}/>
                    {notificationCount !== 0 ? <div className="notify-badge"><p>{notificationCount}</p></div> : null}
                </Link>
                <Link to="/Settings" id={`${props.pageName}SettingLink`}>
                    <img src={settingsIcon} alt="settings" id={`${props.pageName}SettingLink`}/>
                </Link>
            </div>
        </div>
    )
}

export default Toolbar
